import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import styles from './PrimeurSearchBar.module.scss';
import { URLS } from '@/constants/urls';

export const PrimeurSearchBar = ({ designations, setDesignations, searchTerm, setSearchTerm }) => {
  const { t } = useTranslation();
  const designationsList = { ...designations };

  useEffect(() => {
    Object.keys(designationsList).forEach((key) => {
      designationsList[key] = designationsList[key].filter((product) => {
        return product.productName?.toLowerCase().includes(searchTerm) ||
          product.attributes?.appellation?.value?.toLowerCase().includes(searchTerm);
      });
    });
    setDesignations(designationsList);
  }, [searchTerm]);

  const clearSearchBar = () => {
    setSearchTerm('');
    document.getElementById('searchBar').value = '';
  };

  return (
    <div className={styles.container} data-test-id="searchBar" data-rbf="search-bar">
      <div className={styles.searchbar}>
        <img
          className={styles.icon}
          src={URLS.PRIMEUR_SEARCH}
          alt="search"
        />
        <input
          className={styles.input}
          type="text"
          name="searchBar"
          id="searchBar"
          data-test-id="input-searchBar"
          placeholder={t('alert.searchBar')}
          onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
        />
        {searchTerm &&
        <img
          className={`${styles.icon} ${styles['icon-close']}`}
          src={URLS.ORION_CLOSE_BLACK}
          alt="close"
          onClick={() => clearSearchBar()}
          data-test-id="clear"
        />}
      </div>
    </div>
  );
};

PrimeurSearchBar.propTypes = {
  designations: PropTypes.object.isRequired,
  setDesignations: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired
};

export default PrimeurSearchBar;
